import { mapEnumToOptions } from '@abp/ng.core';

export enum TerminalPaymentMethod {
  CardPresent = 0,
  Tap = 1,
  Chip = 2,
  Swipe = 3,
  Contactless = 4,
}

export const terminalPaymentMethodOptions = mapEnumToOptions(TerminalPaymentMethod);
